import { createAsyncThunk } from "@reduxjs/toolkit";
import {IErrorResponse, IRootState} from "../../../../../../../types";
import request from "../../../../../../../service";
import {
    IOrientationCreate, IOrientationPayload
} from "../types";
import {
    deletedOrientation, deletedRestoreOrientation,
    setOrientation, setOrientationRestore
} from "./orientationSlice";



const SetOrientation = createAsyncThunk(
    "create/orientation",
    async ( data : IOrientationCreate,{rejectWithValue}) => {
        try {
            const response = await request.post("/classroom-orientations", data);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const GetOrientation = createAsyncThunk(
    "get/orientation",
    async (_, { dispatch,rejectWithValue,getState }) => {
        try {
            const response = await request.get("/classroom-orientations");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setOrientation({data:response.data,defaultLanguage}));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteOrientation = createAsyncThunk(
    "delete/orientation",
    async (id:number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/classroom-orientations/${id}`);

            dispatch(deletedOrientation(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditOrientation = createAsyncThunk(
    "edit/orientation",
    async ( data : IOrientationPayload, {rejectWithValue }) => {
        try {
            const response = await request.put(`/classroom-orientations/${data.id}`, data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);




const GetDeleteOrientation= createAsyncThunk(
    "get/delete/orientation",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/classroom-orientations/deleted-items`);
            dispatch(setOrientationRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const RestoreDeleteOrientation = createAsyncThunk(
    "restore/delete/orientation",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/classroom-orientations/restore/${id}`);
            dispatch(deletedRestoreOrientation(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);




export {
    GetOrientation,
    DeleteOrientation,
    EditOrientation,
    SetOrientation,
    RestoreDeleteOrientation,
    GetDeleteOrientation
};
